/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
  type: string;
  value: string;
  languageCode: string;
}>;

export const UpdateDescArtist = async (option: Option) => {
  const $id = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const $type = <Variable name="type" scalar={<StringScalar />} value={option.type} />;
  const $value = <Variable name="value" scalar={<StringScalar />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_DESC_ARTIST">
      <SelectionSet
        name="updateArtist_title"
        alias="updateDescArtist"
        argument={{
          where: {
            id: $id
          },
          data: {
            type_artist_title: $type,
            value: $value,
            language: {
              connect: {
                language_code: $languageCode
              }
            }
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateDescArtist: {
      id: string;
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
